import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class AppService {
  constructor(private http: HttpClient) {}
  get(path: string, params?: Record<string, any>) {
    return this.http.get<any>(environment.domain + path, {
      ...(params ? { params } : {}),
      //   withCredentials: true,
    });
  }
  post(
    path: string,
    data: Record<string, any>,
    options?: {
      headers?: Record<string, any>;
      [key: string]: any;
    },
  ) {
    return this.http.post<any>(environment.domain + path, data);
  }
  put(path: string, data?: Record<string, any>, options?: Record<string, any>) {
    return this.http.put<any>(environment.domain + path, data, {
      ...(options ? options : {}),
      //   ...(params ? { params } : {}),
    });
  }
  patch(path: string, data: Record<string, any>, options?: Record<string, any>) {
    return this.http.patch<any>(environment.domain + path, data, {
      ...(options ? options : {}),
      //   ...(params ? { params } : {}),
    });
  }
  delete(path: string, params: Record<string, any>) {
    return this.http.delete<any>(environment.domain + path, {
      ...(params ? { body: params } : {}),
      //   withCredentials: true,
    });
  }
}
